(function ($, Drupal, drupalSettings, cookies) {
  'use strict';

  Theme.all = function (common, options) {
    // Héritage
    this.common = common;

    // Selecteurs
    this.selectors = {
      // EXEMPLES : Data,Hover; Focus...
    };

    // Éléments
    this.elements = {
      html: $('html'),
      body: $('body'),
      blockGalery: $('.paragraph--type--block-galery .galery--content'),
      blockSlider: $('.paragraph--type--block-slider'),
      blockTestimonials: $('.block-testimonials--content'),
      blockProductionsSlider: $('.view-display-productions-slider .view-list--wrapper'),
      blockProductionsTextSlider: $('.view-display-productions-text-slider .view-list--wrapper'),
      blockBigSlider: $('.bigslider'),
      blockSliderArticles: $('.slider-articles'),
      blockNotification: $('.notification-custom'),
    };

    // Variables
    this.toggleMenu = undefined;
    this.rellax = undefined;
    this.fixer = undefined;
  };

  Theme.all.prototype = {
    init: function () {
      if (!this.elements.body.hasClass('initialized')) {
          this.initLazyLoad();
          this.blockMenuMainHandler();
          this.blockMenuSecondaryHandler();
          this.blockMenuLanguageSelectorHandler();
          this.blockGaleryHandler();
          this.blockSliderHandler();
          this.blockTestimonialsHandler();
          this.blockFaqHandler();
          this.blockVideoHandler();
          this.blockSliderReinssuranceHandler();

          this.initBlockNotification();

          this.blockProductionsSlider();
          this.blockProductionsTextSlider();
          this.refreshBlockProductionsTextSlider();

          this.blockBigSlider();
          this.blockSliderArticles();
          /*this.blockMenuShortcuts();*/

          this.listJobOffers();
          this.pageJobOffers();

          this.initReadbar();
          this.initBtnCopyUrl();

          this.initBlockLandingForm();
          this.initBlockSelectForm();
          //this.initHuspotForm();

          this.blockAnimation();

          //this.blockChronoly();

          this.darkMode();
          this.contextualLinks();
          if (!$('body').hasClass('role--authenticated')) {
              this.initEffectsOnScroll();
          }
          this.initFilterListNews();
          this.initParagraphs();
          this.initViewsFiltered('.view-display-list-blog');
          this.initViewsFiltered('.view-display-list-productions');
          this.initViewsFiltered('.view-display-list-news');
          this.refreshParagraphs();
          this.scrollLanding();

          this.elements.body.addClass('initialized');
      }
    },

    load: function () {
      console.log('load');

      this.blockSliderReinssuranceHandler();
    },
    autoload: function (options) {
      console.log('autoload');
    },

    /**
     * Block Menu Main
     */

    blockMenuMainHandler: function () {
        var isPageRH = $('body').hasClass('page-node-type-rh') ||
          $('body').hasClass('page-node-type-page-view-rh') ||
          $('body').hasClass('page-node-type-offre-d-emploi');
        if($('body').hasClass('domain-idex')) {
            var idMenuMain = (isPageRH ? '#block-menu-rh' : '#block-menu-main');
            var idMenuSecondary = (isPageRH ? '#block-menu-secondary-rh' : '#block-menu-secondary');
        }else {
            var idMenuMain = (isPageRH ? '#block-menu-rh-must' : '#block-menu-main-must');
            var idMenuSecondary = (isPageRH ? '#block-menu-secondary-rh-must' : '#block-menu-secondary-must');
        }

        if (!$(idMenuMain).length) {
          return false;
        }

        /** Menu desktop **/
        $('body').on('mouseover touch focus', idMenuMain + ' .level0--link', function (e) {
            e.preventDefault();

            var level0Item = $(this).closest('.level0--item');

            if (!level0Item.hasClass('hover')) {
                $(this).closest('.level0').find('.level0--item.hover').removeClass('hover');
                level0Item.removeClass('inactive').addClass('hover');
                $(this).closest('.level0').find('.level0--item:not(.hover)').addClass('inactive');
            }
        });
        $('body').on('mouseover touch', function(e) {
            if (!e.target.closest(idMenuMain)) {
                if ($(idMenuMain + ' .level0--item.hover').length) {
                    $(idMenuMain + ' .level0--item').removeClass('hover').removeClass('inactive');
                }
            }
        });

        /** Menu mobile **/
        /* construction du menu mobile */
        // modif du dom
        $('body').append($('.btn-menu-mobile'));
        // déplacement d'éléments dans le menu mobile
        $(idMenuMain).after($(idMenuMain).clone().attr('id', idMenuMain.replace('#', '') + '-mobile'));
        $(idMenuMain + '-mobile .level0').append($('#block-menu-shortcuts .level0--link.item--dark-mode').parent().clone());
        $(idMenuMain + '-mobile .level0').append($(idMenuSecondary + ' .level0--item').clone().addClass('colored'));
        $(idMenuMain + '-mobile .level0').find('.level0--link.item--spaces').closest('.level0--item').hide();
        $(idMenuMain + '-mobile .level0').append($('#block-menu-shortcuts .level0--link.item--message').parent().clone().addClass('colored'));

        // appel de MmenuLight
        const menu = new MmenuLight(document.querySelector(idMenuMain + "-mobile"));
        const navigator = menu.navigation({
            title:  'Menu',
            theme:  'light'
        });
        const drawer = menu.offcanvas({
            position: 'right'
        });

        // btn open/close menu
        var timerMenuMobile = null;
        $('body').on('click touch', '.btn-menu-mobile', function (e) {
            e.preventDefault();

            $(this).toggleClass('active');

            if ($(this).hasClass('active')) {
                drawer.open();

                // déplacement de la recherche dan le menu
                $('#block-header-search').wrap('<li class="level0--item menu-mobile-search"></li>')
                $('#block-must-header-search').wrap('<li class="level0--item menu-mobile-search"></li>')
                $(idMenuMain + '-mobile .level0').prepend($('.menu-mobile-search'));

                timerMenuMobile = setInterval(function () {
                    if ($('.mm-ocd:not(.mm-ocd--open)').length) {
                        $('.btn-menu-mobile').removeClass('active');

                        // déplacement du menu dans la recherche
                        $('.pre-header').append($(idMenuMain + '-mobile #block-header-search'));
                        $(idMenuMain + '-mobile .menu-mobile-search').remove();

                        clearInterval(timerMenuMobile);
                    }
                }, 300);
            }
            else {
                drawer.close();

                // déplacement du menu dans la recherche
                $('.pre-header').append($(idMenuMain + '-mobile #block-header-search'));
                $(idMenuMain + '-mobile .menu-mobile-search').remove();

                clearInterval(timerMenuMobile);
            }
        });

        /** Header sticky **/
        if ($(window).scrollTop() > 10) {
            console.log('sticky');
            $('body').addClass('sticky');
        }
        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 10) {
                $('body').addClass('sticky');
            } else {
                $('body').removeClass('sticky');
            }
        });
    },
    /**
     * Block Menu Secondary
     */
    blockMenuSecondaryHandler: function () {
        /** Menu desktop **/
        $('body').on('mouseover touch focus', '#block-menu-secondary .level0--link', function (e) {
            e.preventDefault();

            var level0Item = $(this).closest('.level0--item');

            if (!level0Item.hasClass('active')) {
                $(this).closest('.level0').find('.level0--item.active').removeClass('active');
                level0Item.removeClass('inactive').addClass('active');
            }
        });
        $('body').on('mouseover touch', function(e) {
            if (!e.target.closest('#block-menu-secondary')) {
                if ($('#block-menu-secondary .level0--item.active').length) {
                    setTimeout(function () {
                        $('#block-menu-secondary .level0--item').removeClass('active');
                    }, 300);
                }
            }
        });
    },
    /**
     * Block Menu Language Selector
     */
    blockMenuLanguageSelectorHandler: function () {
        /** Menu desktop **/
        $('body').on('mouseover touch focus', '.blocklanguage-switcher-language-url .show-links', function (e) {
            e.preventDefault();

            $(this).closest('.blocklanguage-switcher-language-url').addClass('active');
        });
        $('body').on('mouseover touch', function(e) {
            if (!e.target.closest('.blocklanguage-switcher-language-url')) {
                if ($('.blocklanguage-switcher-language-url.active').length) {
                    setTimeout(function () {
                        $('.blocklanguage-switcher-language-url').removeClass('active');
                    }, 300);
                }
            }
        });
    },

    /**
     * Block Galery
     */
    blockGaleryHandler: function () {
      var self = this;

      if (self.elements.blockGalery.length) {
        self.elements.blockGalery.each(function () {
            var galeryImages = $(this);
            galeryImages.imagesLoaded( function() {
                galeryImages.masonry({
                    // options
                    //columnWidth: self.elements.blockGalery.find('.paragraph--type--block-image')[1],
                    horizontalOrder: true,
                    percentPosition: true
                });
            });
        });
      }
    },

    /**
     * Block Slider
     */
    blockSliderHandler: function () {
      var self = this;

      if (self.elements.blockSlider.length) {
        self.elements.blockSlider.each(function () {

          // récup param autoplay
          var autoplayTimeout = 0;
          $(this).attr('class').split(' ').forEach(function (item) {
            if (item.indexOf('autoplay-') >= 0) {
              switch (item.replace('autoplay-', '')) {
                case 'slow' :
                  autoplayTimeout = 10000;
                  break;
                case 'fast' :
                  autoplayTimeout = 3000;
                  break;
                case 'normal' :
                  autoplayTimeout = 5000;
                  break;
                default :
                  autoplayTimeout = 0;
              }
            }
          });

          // slide video
          $(this).on('click touch', '.link-video-embed.open-here', function (e) {
            e.preventDefault();

            $(this).addClass('hide');

            // stop autoplay sur le slider
            if ($(this).closest('.block-slider--content').hasClass('owl-carousel')) {
              $(this).closest('.block-slider--content').trigger('stop.owl.autoplay');
            }

            // lecture video
            $(this).closest('.paragraph--type--item-slider-slide').find('.content-video-embed').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
            $(this).closest('.paragraph--type--item-slider-slide').addClass('play-video');
          });

          // init slider
          $(this).find('.block-slider--content').addClass('owl-carousel').owlCarousel({
            rewind: true,
            loop: false,
            autoplay: (autoplayTimeout > 0),
            autoplayTimeout: autoplayTimeout,
            responsiveClass: true,
            autoplayHoverPause: true,
            nav: $(this).hasClass('arrows'),
            navText: [
                '<span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>',
                '<span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>'
            ],
            dots: $(this).hasClass('dots'),
            autoWidth: false,
            autoHeight: true,
            items: 1,
            onChange: function (event) {
              var carousel   = $(event.target);
              //console.log(event.property.name);

              // affichage media
              carousel.closest('.paragraph--type--block-slider').find('.medias .item-slider-slide--media').removeClass('active');
              carousel.closest('.paragraph--type--block-slider').find('.medias .item-slider-slide--media').eq(event.item.index + 1).addClass('active');

              // si navigation dans slider en pause  suite à une lecture d'une vidéo : restart autoplay et stop vidéo
              if (event.property.name == 'position') {
                // restart autoplay
                if (carousel.autoplay) {
                  carousel.trigger('play.owl.autoplay');
                }

                // stop video
                //console.trace($(event.target));
                carousel.find('.paragraph--type--item-slider-slide').removeClass('play-video');
                carousel.find('.paragraph--type--item-slider-slide .content-video-embed').empty();
                carousel.find('.link-video-embed.hide').removeClass('hide');
              }
            },
            onInitialized: function (event) {
              var carousel   = $(event.target);

              carousel.closest('.paragraph--type--block-slider').prepend('<div class="medias"></div>');
              carousel.find('.paragraph--type--item-slider-slide').each(function (index) {
                  carousel.closest('.paragraph--type--block-slider').find('.medias').append($(this).find('.item-slider-slide--media'));
              });

              carousel.closest('.paragraph--type--block-slider').find('.medias .item-slider-slide--media').eq(0).addClass('active');

            },
          });
        });
      }
    },

    /**
     * Block Testimonials
     */
    blockTestimonialsHandler: function () {
      var self = this;

      if (self.elements.blockTestimonials.length) {
        self.elements.blockTestimonials.addClass('owl-carousel').owlCarousel({
          rewind: true,
          loop: false,
          autoplay: false,
          responsiveClass: true,
          autoplayHoverPause: true,
          nav: true,
          navText: [
              '<span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>',
              '<span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>'
          ],
          dots: true,
          autoWidth: false,
            autoHeight: true,
          items: 1
        });

        this.refreshBlockTestimonialsHandler();

        $(window).resize(function() {
            var all = Drupal.Theme.load('all');
            all.refreshBlockTestimonialsHandler();
        });
      }
    },

    /**
    * Block Testimonials : refresh
    */
    refreshBlockTestimonialsHandler: function() {
      if ($(window).outerWidth() < BREAKPOINT_TABLET) {
          // déplacement des boutons en mode mobile/desktop
          $('.item-testimonials-testimony--text-inner .author-title').each(function () {
              $(this).closest('.paragraph--type--item-testimonials-testimony').append($(this));
          });
      }
      else {
          $('.paragraph--type--item-testimonials-testimony > .author-title').each(function () {
              $(this).closest('.paragraph--type--item-testimonials-testimony').find('.item-testimonials-testimony--text-inner').append($(this));
          });
      }
    },

    /**
     * Block Reassurance
     */
    blockSliderReinssuranceHandler: function () {
        this.refreshBlockSliderReinssurance();

        $(window).resize(function() {
            var all = Drupal.Theme.load('all');
            all.refreshBlockSliderReinssurance();
        });
    },

    /**
     * Block Reassurance
     */
    refreshBlockSliderReinssurance: function () {
        var containerReinssurance = $('.paragraph--type--container-reinssurance .paragraph--row');

        if ($(window).outerWidth() < BREAKPOINT_TABLET) {
            if (!containerReinssurance.hasClass('owl-carousel')) {
                containerReinssurance.addClass('owl-carousel').owlCarousel({
                    rewind: true,
                    loop: false,
                    autoplay: true,
                    responsiveClass: true,
                    nav: true,
                    navText: [
                        '<span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>',
                        '<span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>'
                    ],
                    dots: false,
                    autoWidth: false,
                    responsive: {
                        0: {
                            items: 1,
                        }
                    }
                });
            }
        } else {
            if (containerReinssurance.hasClass('owl-carousel')) {
                containerReinssurance.trigger('destroy.owl.carousel').removeClass('owl-carousel');
            }
        }
    },

    /**
     * Block FAQ
     */
    blockFaqHandler: function () {
      $('body').on('click touch', '.paragraph--type--block-faq .field_question', function (e) {
        e.preventDefault();
        $(this).addClass('selected');
        $(this).closest('.paragraph--type--block-faq').find('.field_question:not(.selected)').removeClass('active');
        $(this).removeClass('selected').toggleClass('active');
      });
    },

    /**
     * Block video
     */
    blockVideoHandler: function () {
      $('body').on('click touch', '.paragraph--type--block-video-embed .block-video-embed--link.open-here', function (e) {
        e.preventDefault();
        $(this).closest('.paragraph--type--block-video-embed').find('.block-video-embed--content').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
        //$(this).closest('.paragraph--type--block-video-embed').addClass('play');
      });

      if ($('.paragraph--type--block-video-embed').length) {
          let timerVideo= setInterval(function () {
              $('.paragraph--type--block-video-embed iframe').each(function () {
                  if ($(this).attr('src') != undefined) {
                      $(this).closest('.paragraph--type--block-video-embed').addClass('play');
                      $(this).css('visibility', 'visible');
                      if ($(this).closest('.paragraph--type--block-video-embed').find('.consent').length) {
                          $(this).closest('.paragraph--type--block-video-embed').find('.consent').remove();
                      }
                  } else {
                      $(this).closest('.paragraph--type--block-video-embed').removeClass('play');
                      $(this).css('visibility', 'hidden');
                      if (!$(this).closest('.paragraph--type--block-video-embed').find('.consent').length) {
                          $(this).closest('.paragraph--type--block-video-embed').append('<div class="consent">Vous devez autoriser les cookies afin de pouvoir visualiser cette vidéo.</div>');
                      }
                  }
              });
          }, 500);
      }
    },

      /**
       * Block Notification
       */
      initBlockNotification: function () {
          var self = this;

          if (self.elements.blockNotification.length) {
              let idNotification = self.elements.blockNotification.data('id');
              if (typeof cookies.get('notification-' + idNotification) == 'undefined') {
                  self.elements.blockNotification.show();
              }

              $('body').on('click touch', '.notification-custom .notification-custom--close', function (e) {
                  e.preventDefault();

                  $(this).closest('.notification-custom').hide();

                  // création d'un cookie pour ne plus afficher cette notification
                  let expDateCookie = new Date();
                  expDateCookie.setTime(expDateCookie.getTime() + (1000 * 60 * 60 * 24 * 30)); // 30 jours
                  cookies.set('notification-' + idNotification, 0, { path: '/', expires: expDateCookie });
              });
          }
      },

      /**
       * Block productions slider
       */
      blockProductionsSlider: function () {
          var self = this;

          if (self.elements.blockProductionsSlider.length) {
              self.elements.blockProductionsSlider.addClass('owl-carousel').owlCarousel({
                  autoplay: false,
                  responsiveClass: true,
                  autoplayHoverPause: true,
                  nav: true,
                  navText: [
                      '<span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>',
                      '<span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>'
                  ],
                  dots: true,
                  autoWidth: false,
                  margin: 20,
                  stagePadding: 0,
                  responsive:{
                      0:{
                          loop: (self.elements.blockProductionsSlider.find('.view-item').length > 1),
                          items: 1,
                      },
                      576: {
                          loop: (self.elements.blockProductionsSlider.find('.view-item').length > 2),
                          items: 2,
                      },
                      768:{
                          loop: (self.elements.blockProductionsSlider.find('.view-item').length > 3),
                          items: 3,
                      },
                      1200:{
                          loop: (self.elements.blockProductionsSlider.find('.view-item').length > 4),
                          items: 4,
                      },
                  }
              });
          }
      },
      /**
       * Block productions text slider
       */
      blockProductionsTextSlider: function () {
          var self = this;

          if (self.elements.blockProductionsTextSlider.length) {
              self.elements.blockProductionsTextSlider.addClass('owl-carousel').owlCarousel({
                  autoplay: false,
                  responsiveClass: true,
                  autoplayHoverPause: true,
                  nav: true,
                  navText: [
                      '<span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>',
                      '<span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>'
                  ],
                  autoWidth: false,
                  margin: 20,
                  stagePadding: 0,
                  responsive:{
                      0:{
                          loop: (self.elements.blockProductionsTextSlider.find('.view-item').length > 1),
                          items: 1,
                          slideBy: 1,
                          dots: false,
                      },
                      576: {
                          loop: (self.elements.blockProductionsTextSlider.find('.view-item').length > 2),
                          items: 2,
                          slideBy: 2,
                          dots: false,
                      },
                      768:{
                          loop: (self.elements.blockProductionsTextSlider.find('.view-item').length > 3),
                          items: 3,
                          slideBy: 3,
                          dots: true,
                      },
                  }
              });

              this.refreshBlockProductionsTextSlider();

              $(window).resize(function() {
                  var all = Drupal.Theme.load('all');
                  all.refreshBlockProductionsTextSlider();
              });
          }
      },

      /**
       * Block big slider : refresh
       */
      refreshBlockProductionsTextSlider: function() {
          if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
              // déplacement des boutons en mode mobile/desktop
              $('.view-display-productions-text-slider .view-header .btn-group').each(function () {
                  $(this).closest('.view-display-productions-text-slider').append($(this));
              });
          }
          else {
              $('.view-display-productions-text-slider > .btn-group').each(function () {
                  $(this).closest('.view-display-productions-text-slider').find('.view-header').append($(this));
              });
          }
      },

      /**
       * Block big slider
       */
      blockBigSlider: function () {
          var self = this;
          var timeoutFirstSlide = '5000';

          if (self.elements.blockBigSlider.length && self.elements.blockBigSlider.find('.paragraph--type--item-bigslider-slide').length > 1) {
              self.elements.blockBigSlider.closest('.paragraph--type--container-bigslider').append('<div class="bigslider--labels-wrapper">');
              self.elements.blockBigSlider.closest('.paragraph--type--container-bigslider').find('.bigslider--labels-wrapper').append('<div class="bigslider--labels">');
              self.elements.blockBigSlider.find('.paragraph--type--item-bigslider-slide').each(function (index) {
                  //.find('.bigslide--label').each(function (index) {

                  // slide video : modif autoplay
                  var timeoutSlide = '5000';
                  if ($(this).find('video').length) {
                      timeoutSlide = '15000';
                      $(this).addClass('video');
                  }
                  $(this).attr('data-timeout', timeoutSlide);
                  if (index == 0) {
                      timeoutFirstSlide = timeoutSlide;
                  }

                  var label = $(this).find('.bigslide--label');
                  label.attr('tabindex', 0);

                  // ajout d'un id
                  label.attr('data-slideid', index);
                  label.closest('.paragraph--type--item-bigslider-slide').attr('data-slideid', index);

                  // déplacement des labels en dehors des slides
                  label.closest('.paragraph--type--container-bigslider').find('.bigslider--labels').append(label);

                  if (index == 0) {
                      label.addClass('active');
                  }
              });

              self.elements.blockBigSlider.addClass('owl-carousel').owlCarousel({
                  rewind: true,
                  loop: false,
                  autoplay: true,
                  autoplayTimeout: timeoutFirstSlide,
                  responsiveClass: true,
                  autoplayHoverPause: false,
                  nav: true,
                  navText: [
                      '<span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>',
                      '<span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>'
                  ],
                  dots: false,
                  autoWidth: false,
                  autoHeight: true,
                  items: 1,
                  onInitialized: function (event) {
                      var carousel   = $(event.target);

                      carousel.closest('.paragraph--type--container-bigslider').find('.bigslide--label').on('click touch', function(e) {
                          //carousel.trigger('stop.owl.autoplay');    // reset autoplayTimeout
                          carousel.trigger('to.owl.carousel', $(this).attr('data-slideid'));
                          //carousel.trigger('start.owl.autoplay');
                      });

                      // lecture auto de la video (sur certains navigateurs  l'absence d'attribut desactive l'autoplay)
                      /*var slideSelected = carousel.find('.owl-item').eq(event.item.index);
                      if (slideSelected.find('video').length) {
                          slideSelected.find('video')[0].play();
                      }*/
                  },

                  onTranslated: function (event) {
                      var carousel   = $(event.target);

                      var slideSelected = carousel.find('.owl-item').eq(event.item.index);
                      var timeoutSlide = slideSelected.find('.paragraph--type--item-bigslider-slide').attr('data-timeout');

                      // modif autoplay suivant type de slide
                      carousel.trigger('stop.owl.autoplay');
                      carousel.trigger('play.owl.autoplay', timeoutSlide);

                      var numSlideSelected = slideSelected.find('.paragraph--type--item-bigslider-slide').attr('data-slideid');
                      var labelSelected = carousel.closest('.paragraph--type--container-bigslider').find('.bigslide--label[data-slideid="' + numSlideSelected + '"]');

                      labelSelected.addClass('selected');
                      carousel.closest('.paragraph--type--container-bigslider').find('.bigslide--label.active:not(".selected")').removeClass('active');
                      labelSelected.removeClass('selected').addClass('active');

                      // lecture stopée pour toutes les videos des slides
                      /*carousel.find('.owl-item').each(function() {
                        if ($(this).find('video').length) {
                            var objVideo = $(this).find('video')[0];
                            objVideo.pause();
                            objVideo.currentTime  = 0;
                        }
                      });*/

                      // lecture auto de la video (sur certains navigateurs  l'absence d'attribut desactive l'autoplay)
                      /*if (slideSelected.find('video').length) {
                          slideSelected.find('video')[0].play();
                      }*/
                  }
              });

              self.elements.blockBigSlider.on('mouseover', function(e) {
                  //console.log('stop');
                  self.elements.blockBigSlider.trigger('stop.owl.autoplay');
              });
              self.elements.blockBigSlider.on('mouseout', function(event) {
                  //console.log('start');
                  var slideSelected = self.elements.blockBigSlider.find('.owl-item.active .paragraph--type--item-bigslider-slide');
                  var timeoutSlide = slideSelected.attr('data-timeout');
                  self.elements.blockBigSlider.trigger('play.owl.autoplay', timeoutSlide);
              });

              self.elements.blockBigSlider.on('changed.owl.carousel', function(e) {
                  self.elements.blockBigSlider.trigger('stop.owl.autoplay');
                  self.elements.blockBigSlider.trigger('play.owl.autoplay');
              });
          }

          /*self.elements.blockBigSlider.closest('.paragraph--type--container-bigslider').find('.bigslider--labels').addClass('owl-carousel').owlCarousel({
              loop: false,
              autoplay: false,
              responsiveClass: true,
              autoplayHoverPause: false,
              nav: false,
              dots: false,
              autoWidth: false,
              autoHeight: false,
              stagePadding: 0,
              responsive:{
                  0:{
                      items: 1.33,
                      center: true
                  },
                  768:{
                      items:2.25,
                      center: true
                  },
                  1024:{
                      items:4,
                      center: false
                  }
              }
          });*/

      },

      blockSliderArticles: function () {
          var self = this;

          if (self.elements.blockSliderArticles.length) {
              self.elements.blockSliderArticles.addClass('owl-carousel').owlCarousel({
                  rewind: true,
                  loop: true,
                  autoplay: true,
                  responsiveClass: true,
                  autoplayHoverPause: true,
                  nav: true,
                  navText: [
                      '<span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>',
                      '<span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>'
                  ],
                  dots: true,
                  autoWidth: false,
                  autoHeight: true,
                  items: 1
              });

              this.refreshBlockTestimonialsHandler();

              $(window).resize(function() {
                  var all = Drupal.Theme.load('all');
                  all.refreshBlockTestimonialsHandler();
              });
          }
      },

      /**
       * Block menu shortcuts
       */
      /*blockMenuShortcuts: function () {
          if ($(window).scrollTop() > 200) {
              $('#block-menu-shortcuts').addClass('visible');
          }
          else {
              $('#block-menu-shortcuts').removeClass('visible');
          }

          $(window).on('scroll', function () {
              if ($(window).scrollTop() > 200) {
                  $('#block-menu-shortcuts').addClass('visible');
              }
              else {
                  $('#block-menu-shortcuts').removeClass('visible');
              }
          });
      },*/
      /**
       * Block blockChronoly
       */
      /*blockChronoly: function () {
          this.blockChronolyRefreshHandler();

          $(window).on('scroll', function () {
              var all = Drupal.Theme.load('all');
              all.blockChronolyRefreshHandler();
          });
      },*/
      /**
       * Block blockChronolyRefreshHandler
       */
      /*blockChronolyRefreshHandler: function () {
          $('.paragraph--type--container-chronology .chronology--item-wrapper').each(function () {

              if ($(window).scrollTop() + ($(window).innerHeight() * 3 / 4) > $(this).offset().top) {
                  $(this).addClass('on-view');
              }
              else {
                  $(this).removeClass('on-view');

              }
          });
      },*/
      /**
       * Block menu shortcuts
       */
      darkMode: function () {
        $('.item--dark-mode').on('click touch', function (e) {
          e.preventDefault();
          $('body').toggleClass('dark-side');

          $('.item--dark-mode .label').each(function () {
            var dateCookie = new Date();

            if ($('body').hasClass('dark-side')) {
              var all = Drupal.Theme.load('all');

              $(this).attr('data-text-init', $(this).text()).text(all.common.darkSideTextBack);
              if (typeof cookies.get('idexdarkmode') !== 'undefined') {
                  cookies.set('idexdarkmode', 1, { path: '/' });
                  cookies.set('idexdarkmode-date', dateCookie.getTime(), { path: '/' });
              }
            }
            else {
              $(this).text($(this).attr('data-text-init'));
              if (typeof cookies.get('idexdarkmode') !== 'undefined') {
                  cookies.set('idexdarkmode', -1, { path: '/' });
                  cookies.set('idexdarkmode-date', dateCookie.getTime(), { path: '/' });
              }
            }
          });
        });
      },
      /**
       * Contextual links
       */
      contextualLinks: function () {
          // items
          var strContextualLinks = '';
          $('.paragraph--type--item-container-header').each(function () {
              if ($(this).attr('id') && $(this).attr('data-label'))
              strContextualLinks += '<li><a href="#' + $(this).attr('id') + '" id="contextual-link--' + $(this).attr('id') + '">' + $(this).attr('data-label') + '</a></li>';
          });
          if (strContextualLinks != '') {
              $('.field_reference').prepend('<div class="contextual-links"><div class="contextual-links--wrapper"><ul>' + strContextualLinks + '</ul></div></div>');


              $('.contextual-links').attr('data-init-offset-top', $('.contextual-links').offset().top);
              $('.contextual-links').attr('data-init-height', $('.contextual-links--wrapper').outerHeight());

              $('.contextual-links .contextual-links--wrapper a').on('click touch', function (e) {
                  e.preventDefault();
                  var target = $(this).attr('href');
                  var topAnchor = $(target).offset().top - 170 - $('.contextual-links').outerHeight();

                  $('html, body').stop().animate({scrollTop: topAnchor}, 400);
              });
          }

          // barre de scroll
          $('.contextual-links--wrapper').append('<div class="scroll-bar"></div>')

          // refresh
          this.contextualLinksRefreshHander();

          $(window).on('scroll', function () {
              var all = Drupal.Theme.load('all');
              all.contextualLinksRefreshHander();
          });
      },


      /**
       * contextualLinksRefreshHander
       */
      contextualLinksRefreshHander: function () {
          var all = Drupal.Theme.load('all');
          var menuContextualTop = $('.contextual-links').attr('data-init-offset-top');
          var menuContextualHeight = $('.contextual-links').attr('data-init-height');
          let topPosition = $('.header-site').outerHeight();
          if ($('.readbar.sticky').length > 0) {
              topPosition += $('.readbar.sticky').outerHeight();
          }
          // items
          if (($(window).scrollTop() + topPosition) >= menuContextualTop) {
              $('.contextual-links').css('height', menuContextualHeight);

              $('.contextual-links--wrapper').css('top', topPosition + 5);
              $('body').addClass('contextual-links-sticky');
          }
          else {
              $('.contextual-links').css('height', 'auto');
              $('.contextual-links--wrapper').css('top', 'auto');
              $('body').removeClass('contextual-links-sticky');
          }

          var deltaTop = parseInt($('.header-site').outerHeight()) + parseInt($('.contextual-links').attr('data-init-height'));
          var activeLink = "";
          $('.contextual-links .contextual-links--wrapper a').each(function () {
              var idLink = '#' + $(this).attr('id');
              var paragRoot = $(idLink.replace('contextual-link--', '')).closest('.paragraph-root');

              if (all.isScrolledIntoView(paragRoot, deltaTop, $(window).height() / 4)) {
                  //$('.contextual-links .contextual-links--wrapper a.active').removeClass('active');
                  //$(this).addClass('active');
                  activeLink = idLink;
              }
              /*else {
                  $(this).removeClass('active');
              }*/
          });

          if (activeLink != "") {
              $('.contextual-links .contextual-links--wrapper a.active').removeClass('active');
              $(activeLink).addClass('active');
          }

          // barre de scroll
          //console.log(($(window).scrollTop() - $('.field_reference').offset().top) + "*" + $('.contextual-links--wrapper').outerWidth() + "/" + $('.field_reference').outerHeight());
          var widthScrollBar = ($(window).scrollTop()) * $('.contextual-links--wrapper').outerWidth() / $('.field_reference').outerHeight();
          $('.contextual-links .scroll-bar').css('width', widthScrollBar);

      },

      /**
       * isScrolledIntoView
       */
      isScrolledIntoView: function (elem, deltaViewportTop, deltaBoundTop){
        var win = $(window);
        var viewport = {
            top : win.scrollTop() + deltaViewportTop,
            left : win.scrollLeft()
        };
        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height() - deltaViewportTop;

        var bounds = elem.offset();
        bounds.right = bounds.left + elem.outerWidth();
        bounds.bottom = bounds.top + elem.outerHeight();

        return (!(
            viewport.right < bounds.left ||
            viewport.left > bounds.right ||
            viewport.bottom < bounds.top + deltaBoundTop ||
            viewport.top > bounds.bottom
        ));
       },


      /**
       * initEffectsOnScroll
       */
      initEffectsOnScroll: function (){
          var optionReset = false;
          var optionDelay = 200;
          var options;
          var delai;



          // animation des titres
          options = { reset: optionReset, delay: 0, duration: 800, distance: '50px', origin: 'left', opacity: 0, interval: 150 };
          ScrollReveal().reveal(
              '.effects-enabled .content-page-header--wrapper .title1, ' +
              '.effects-enabled .content-page-header--wrapper .field_header_text',
              options
          );
          options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0 };
          ScrollReveal().reveal('.effects-enabled .paragraph--type--item-container-header', options);

          // animation des chiffres

          $('.effects-enabled .wysiwyg .numerator').each(function (index) {
              if ($(this).closest('.owl-carousel').length <= 0) {
                  options = {
                      reset: optionReset, delay: 0, duration: 600, origin: 'bottom', opacity: 0,
                      afterReveal: function (el) {
                          var all = Drupal.Theme.load('all');
                          all.animateNumber($(el));
                      }
                  };
                  ScrollReveal().reveal('.effects-enabled .wysiwyg .numerator', options);
              }
          });

          // animation des icônes réseaux sociaux du footer
          options = {reset: optionReset, delay: optionDelay, duration: 1000, origin: 'bottom', opacity: 0, scale: 1.5 };
          ScrollReveal().reveal($('.effects-enabled').closest('body').find('#block-menu-social-media .level0--item'), options);

          // animation des cards se trouvant dans des vues
          options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
          ScrollReveal().reveal($('.effects-enabled .views-element-container .view-list--wrapper > .view-item'), options);

          // animation des questions de la faq
          options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'right', opacity: 0, interval: 200 };
          ScrollReveal().reveal($('.effects-enabled .paragraph--type--block-faq .field_question'), options);

          // animation pour les boutons
          options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 100 };
          ScrollReveal().reveal($('.effects-enabled .paragraph-root .btn, .paragraph-root .button'), options);

          // animation des boutons "+" des secteurs
          options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0, scale: 2, interval: 150 };
          ScrollReveal().reveal($('.effects-enabled .paragraph--type--container-sectors .col-picture .pointer'), options);

          // animation de la liste des pages relatives
          options = { reset: optionReset, delay: 0, duration: 1000, distance: '50px', origin: 'bottom', opacity: 0 };
          ScrollReveal().reveal($('.effects-enabled .related-pages-form'), options);

          // animation paragraphe citation
          options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0, scale: 1.5, interval: 200 };
          ScrollReveal().reveal(
              $('.effects-enabled .paragraph--type--block-citation .field_sentence'),
              options
          );
          options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
          ScrollReveal().reveal(
              $('.effects-enabled .paragraph--type--block-citation .field_author, ' +
                  '.effects-enabled .paragraph--type--block-citation .field_author_title'),
              options
          );

          // animation objets divers
          options = { reset: optionReset, delay: 300, duration: 600, origin: 'bottom', opacity: 0, scale: 2 };
          ScrollReveal().reveal(
              $('.effects-enabled .paragraph--type--block-video-embed .block-video-embed--btn, ' +
                  '.effects-enabled .paragraph--type--item-chronology-element .field_picto'),
              options
          );

          // animation alternée des paragraphes roots
          var cptParagraphRoot = 0;
          $('.effects-enabled .paragraph-root').each(function (index) {

              // animation pour paragraphe de type "2 colonnes"
              if ($(this).hasClass('paragraph--type--container-2col') ||
                  $(this).hasClass('paragraph--type--container-2wysiwyg') ||
                  $(this).hasClass('paragraph--type--container-sectors') ||
                  $(this).hasClass('paragraph--type--container-faq') ||
                  $(this).hasClass('paragraph--type--container-image-text') ||
                  $(this).hasClass('paragraph--type--container-video-text')) {

                  // sous paragraphes
                  $(this).find('.paragraph--row > *').each(function (index) {
                      if ($(this).closest('.paragraph-root').hasClass('display-rtl')) {
                          var origin = (index % 2 == 0 ? 'right' : 'left');
                      }
                      else {
                          var origin = (index % 2 == 0 ? 'left' : 'right');
                      }
                      options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                      ScrollReveal().reveal($(this), options);
                  });
              }
              // animation pour paragraphe contenant des cards
              else if ($(this).hasClass('paragraph--type--container-3col') ||
                  $(this).hasClass('paragraph--type--container-4col') ||
                  $(this).hasClass('paragraph--type--container-reinssurance') ||
                  $(this).hasClass('paragraph--type--container-content-ref')) {
                  if ($(this).find('.owl-carousel').length <= 0) {
                    options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
                    ScrollReveal().reveal($(this).find('.paragraph--row .paragraph--type--block-card'), options);
                  }
              }

              // animation pour paragraphe chronologie
              else if ($(this).hasClass('paragraph--type--container-chronology')) {
                  // sous paragraphes
                  $(this).find('.chronology--item-text').each(function (index) {
                      var origin = (index % 2 == 0 ? 'left' : 'right');
                      options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                      ScrollReveal().reveal($(this), options);
                  });
              }

              // animation pour paragraphe galery
              else if ($(this).hasClass('paragraph--type--container-galery')) {
                  options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
                  ScrollReveal().reveal($(this).find('.paragraph--type--block-image'), options);
              }
              // animations pour paragraphes de type "multilignes"
              else if ($(this).hasClass('paragraph--type--container-images-texts')) {
                  cptParagraphRoot++;

                  // sous paragraphes
                  $(this).find('.container-images-texts--content > li').each(function (index) {
                      var origin = (index % 2 == 0 ? 'right' : 'left');
                      options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                      ScrollReveal().reveal($(this), options);
                  });
              }
              // animation pour autres paragraphes
              else if (!$(this).hasClass('paragraph--type--container-wysiwyg') &&
                  !$(this).hasClass('paragraph--type--container-bigslider') &&
                  !$(this).hasClass('paragraph--type--container-citation') &&
                  !$(this).hasClass('paragraph--type--container-webform')) {
                  cptParagraphRoot++;

                  var origin = (index % 2 == 0 ? 'right' : 'left');
                  options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                  ScrollReveal().reveal($(this), options);
              }
          });

      },

      /**
       * animateNumber
       */
      animateNumber: function (el){
          var valEl = el.text().replace(' ', '').replace(',', '.');

          if (valEl.indexOf('.') > 0) {
              var nbDec = valEl.split(".")[1].length;
              if (!isNaN(valEl)) {
                  var valNumber = parseFloat(valEl);
                  el.text('0').numerator({
                      duration: 2000,
                      toValue: valNumber,
                      delimiter: ' ',
                      rounding: nbDec,
                  });
              }
          }
          else if (!isNaN(valEl)) {
              var valNumber = parseInt(valEl);
              el.text('0').numerator({
                  duration: 2000,
                  toValue: valNumber,
                  delimiter: ' ',
              });
          }

      },

      /**
       * initFilterListNews
       */
      initFilterListNews: function () {
          /*$('.view-display-list-news > .views-exposed-form').each(function () {
              $(this).addClass('filter-list-news').closest('.field_2blocks').before($(this));
          });*/
      },

      /**
       * initParagraphs
       */
      initParagraphs: function () {
          // desactivation des sauts de ligne avant les ponctuations
          $('.paragraph--type--item-container-header .title2').each(function () {
              var htmlTitle = $(this).html().replace(/ \?/, '&nbsp;?').replace(/ \:/, '&nbsp;:').replace(/ \;/, '&nbsp;;').replace(/ \!/, '&nbsp;!');
              $(this).html(htmlTitle);
          });

          this.refreshParagraphs();
          $(window).resize(function() {
              var all = Drupal.Theme.load('all');
              all.refreshParagraphs();
          });
      },

      /**
       * initViewsFiltered
       */
      initViewsFiltered: function (classView) {
          if ($(classView).length > 0) {
              // ajout d'un résumé des filtres sélectionnés
              $(classView + ' .filters-summary').html('');
              $(classView).find(".form-radios input[type='radio'][checked='checked']:not([value='All'])").each(function () {
                  let filterSelected = $('<span class="filterSelected" data-name="' + $(this).attr('name') + '" tabindex="0">' + $(this).next().text() + '</span>');
                  filterSelected.on('click touch', function (e) {
                      e.preventDefault();

                      $(classView).find(".form-radios input[type='radio'][name='" + $(this).data('name') + "'][value='All']").click();
                  });
                  $(classView + ' .filters-summary').append(filterSelected);
              });

              // filtres
              $(classView + ' .fieldset-legend:not(.loaded)').on('click touch', function (e) {
                  e.preventDefault();

                  if ($(this).closest('.fieldgroup').hasClass('active')) {
                      $(this).closest('.fieldgroup').removeClass('active');
                  }
                  else {
                      $(this).closest(classView).find('.fieldgroup.active').removeClass('active');
                      $(this).closest('.fieldgroup').addClass('active');
                  }
              });
              $(classView + ' .fieldset-legend').addClass('loaded');

              $('body').on('click touch', function(e) {
                  if (!e.target.closest(classView + ' .filters-wrapper')) {
                      $(classView).find('.fieldgroup.active').removeClass('active');
                  }
              });
          }
      },

      /**
       * refreshParagraphs
       */
      refreshParagraphs: function () {
          if ($(window).outerWidth() < BREAKPOINT_TABLET) {
              // déplacement des footers après le contenu des paragraphes
              $('.paragraph--type--container-image-text .paragraph--row .paragraph--type--item-container-footer').each(function () {
                  $(this).closest('.paragraph--type--container-image-text').find('.paragraph--wrapper').append($(this));
              });
          }
          else {
              $('.paragraph--type--container-image-text .paragraph--wrapper > .paragraph--type--item-container-footer').each(function () {
                  $(this).closest('.paragraph--type--container-image-text').find('.col-text--wrapper').append($(this));
              });
          }
      },

      scrollLanding: function (){
          document.querySelectorAll('a[href^="#videos"]').forEach(anchor => {
              anchor.addEventListener('click', function (e) {
                  e.preventDefault();

                  document.querySelector(this.getAttribute('href')).scrollIntoView({
                      behavior: 'smooth'
                  });
              });
          });
      },

      /**
       * Lazy load
       */
      initLazyLoad: function () {
          // si image lazy encore non chargée : ajout d'une classe loading permettant un effet à la fin du chargement
          $('img[loading="lazy"]').each(function () {
              if (!$(this)[0].complete && $(this)[0].naturalHeight === 0) {
                  $(this).addClass('loading');
                  $(this).on('load',function() {
                      $(this).removeClass('loading').addClass('loaded');
                  });
              }
          });
      },

      /**
       * pageJobOffers
       */
      pageJobOffers: function () {
          // filtres sticky
          if ($('.views-exposed-form--content').length > 0) {
            let topFilters = $('.views-exposed-form--content').offset().top - $('.header-site--wrapper').innerHeight() - 5;
            if ($(window).scrollTop() > topFilters) {
              $('.views-exposed-form--wrapper').css('height', $('.views-exposed-form--wrapper').outerHeight());
              $('body').addClass('filters-sticky');
            }
            $(window).on('scroll', function () {
              if ($(window).scrollTop() > topFilters) {
                $('.views-exposed-form--wrapper').css('height', $('.views-exposed-form--wrapper').outerHeight());
                $('body').addClass('filters-sticky');
              } else {
                $('.views-exposed-form--wrapper').css('height', 'auto');
                $('body').removeClass('filters-sticky');
              }
            });
          }

          // bouton retour
          $('body.page-node-type-offre-d-emploi').on('click touch', '.btn-link-back', function (e) {
            e.preventDefault();
            //if (document.referrer.match(/\/job-offers$/) != null) {
              window.history.back();
            /*} else {
              document.location.href = "/job-offers";
            }*/
          });

          // bouton "en savoir plus"
          $('body.page-node-type-offre-d-emploi .btn-see-more').on('click touch', function (e) {
            e.preventDefault();
            var target = $(this).attr('href');
            console.log(target);
            var topAnchor = $(target).offset().top - 84;

            $('html, body').stop().animate({scrollTop: topAnchor}, 400);
          });

          // bouton de copie de l'url
          $('body.page-node-type-offre-d-emploi').on('click touch', '.btn-copy-url', function (e) {
            e.preventDefault();

            var objText = document.createElement('TEXTAREA');
            objText.textContent = document.location.href;
            document.body.appendChild(objText);
            objText.select();
            document.execCommand('copy');
            objText.parentNode.removeChild(objText);

            alert("L'url a été copiée dans le presse-papier");
          });
      },

      /**
       * listJobOffers
       */
      listJobOffers: function () {
        // déplacement du breadcrumb après les critères de recherche
        $('.view-post-header').replaceWith($('#block-breadcrumbs').clone());

        // bouton reset ajax
        //$(document).ajaxComplete(function( event, xhr, settings ) {
        //  if (!$(".edit-reset").length){
        //    $("[id='views-exposed-form-job-offers-list-jobs']").find('.form-actions').append('<button onclick="javascript:jQuery(this.form).clearForm();jQuery(this.form).find(\'.form-submit\').trigger(\'click\');return false;" class="button edit-reset">' + Drupal.t('Réinitialiser') + '</button>');
        //  }
        //});

        // slider jobs
        if ($('.view-display-slider-jobs .view-list--wrapper').find('.view-item').length <= 1) {
            $('.view-display-slider-jobs .view-list--wrapper').addClass('no-slider');
        }
        else {
            $('.view-display-slider-jobs .view-list--wrapper').addClass('owl-carousel').owlCarousel({
                rewind: true,
                loop: false,
                autoplay: true,
                responsiveClass: true,
                autoplayHoverPause: true,
                nav: true,
                navText: [
                    '<span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>',
                    '<span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/drup_theme/images/sprites.svg#fleche"></use></svg>'
                ],
                dots: true,
                autoWidth: false,
                autoHeight: true,
                items: 1
            });
        }
      },

      /**
       * initBtnCopyUrl
       */
      initBtnCopyUrl: function () {
          // bouton de copie de l'url
          $('.btn-copy-url').on('click touch', function (e) {
              e.preventDefault();

              var objText = document.createElement('TEXTAREA');
              objText.textContent = document.location.href;
              document.body.appendChild(objText);
              objText.select();
              document.execCommand('copy');
              objText.parentNode.removeChild(objText);

              alert("L'url a été copiée dans le presse-papier");
          });
      },


      /**
       * Init readbar
       */
      initReadbar: function() {
          let $readBar = $('.readbar');
          if ($readBar.length) {
              let refreshReadbar = function() {
                  let headerSiteHeight = $('.header-site').outerHeight();
                  let $contentPageInner = $('.content-page-inner');

                  if ($(window).scrollTop() >= headerSiteHeight) {
                      if (!$readBar.hasClass('sticky')) {
                          $readBar.addClass('sticky');
                      }
                      $readBar.css('top', headerSiteHeight);

                      if (!$readBar.find('.progressbar').length) {
                          $readBar.append('<div class="progressbar"></div>');
                      }
                      let withProgressBar = ($(window).scrollTop() - $contentPageInner.offset().top + headerSiteHeight + $readBar.outerHeight()) * 100 / $contentPageInner.outerHeight();
                      $readBar.find('.progressbar').css('width', withProgressBar + '%');
                  } else {
                      $readBar.removeClass('sticky');
                  }
              }

              setTimeout(refreshReadbar, 400);
              $(window).on('scroll', function () {
                  var all = Drupal.Theme.load('all');
                  setTimeout(refreshReadbar, 400);
              });
          }
      },

      initBlockSelectForm: function() {
          $("#edit-subject").change(function() {
              const optionValue = $(this).val();
              // Construct URLSearchParams object instance from current URL querystring.
              var queryParams = new URLSearchParams(window.location.search);

              // Set new or modify existing parameter value.
              queryParams.set("subject", optionValue);

              // Replace current querystring with the new one.
              history.replaceState(null, null, "?"+queryParams.toString());
          });
      },


      /**
       * Init Block Landing form
       */
      initBlockLandingForm: function() {

          if ($('.page-node-type-landing').length) {
              this.refreshBlockLandingForm();

              $(window).on('scroll', function () {
                  var all = Drupal.Theme.load('all');
                  all.refreshBlockLandingForm();
              });
              $(window).resize(function() {
                  var all = Drupal.Theme.load('all');
                  all.refreshBlockLandingForm();
              });

              // label des inputs
              //$('body').on('focus', '.page-node-type-landing .form-text', function (e) {
              $('.page-node-type-landing .form-text, .page-node-type-landing .form-email')
                  .each(function() {
                      if ($(this).val() != '') {
                          $(this).closest('.form-item').addClass('active');
                      }
                  })
                  .focus(function(e) {
                      e.preventDefault();
                      $(this).closest('.form-item').addClass('active');
                  })
                  .blur(function(e) {
                      e.preventDefault();
                      if ($(this).val() == '') {
                          $(this).closest('.form-item').removeClass('active');
                      }
                  });

              // popin détails
              $('body').on('click touch', '.show-details', function (e) {
                  e.preventDefault();

                  $('#details').toggleClass('show');
              });

          }

          // landing form des pages prédéfinies
          if ($('.landing-form').length) {
              // label des inputs
              //$('body').on('focus', '.page-node-type-landing .form-text', function (e) {
              $('.landing-form .form-text, .landing-form .form-email, .landing-form .form-select')
                  .each(function() {
                      if ($(this).val() != '') {
                          $(this).closest('.form-item').addClass('active');
                      }
                  })
                  .focus(function(e) {
                      e.preventDefault();
                      $(this).closest('.form-item').addClass('active');
                  })
                  .blur(function(e) {
                      e.preventDefault();
                      if ($(this).val() == '') {
                          $(this).closest('.form-item').removeClass('active');
                      }
                  });
              $('.landing-form').on('submit', function (e) {
                  var response = grecaptcha.getResponse();

                  //recaptcha failed validation
                  if(response.length == 0) {
                      e.preventDefault();
                      $('#recaptcha-error').removeClass('is-hidden');
                  }
                  //recaptcha passed validation
                  else {
                      $('#recaptcha-error').addClass('is-hidden');
                  }
                  return (!e.isDefaultPrevented());
              });
          }
      },

      /**
       * Refresh Block Lanfing form
       */
      refreshBlockLandingForm: function() {
          let blockLandingForm = $('.page-node-type-landing .landing-header-form');
          if ($(window).outerWidth() >= BREAKPOINT_DESKTOP) {

              //let footerTop = $('.footer-landing-page').offset().top;

              //let blockLandingFormHeight = $('.landing-header-form--wrapper').outerHeight();
              //let headerSiteHeight = 60; //$('.header-site-top').outerHeight();

              //if (footerTop - 30 - $(window).scrollTop() >= blockLandingFormHeight + 30 + headerSiteHeight) {
              //if ($(window).scrollTop() >= headerSiteHeight) {
              if (!blockLandingForm.hasClass('sticky')) {
                  blockLandingForm.addClass('sticky');
              }
              //else {
              //    blockLandingForm.removeClass('sticky');
              //}
          }
          else {
              blockLandingForm.removeClass('sticky');
          }
      },


    /**
     * blockAnimation
     */
      blockAnimation: function() {

        this.refreshBlockAnimation();

        $(window).on('scroll', function () {
          var all = Drupal.Theme.load('all');
          all.refreshBlockAnimation();
        });
      },

      /**
       * refreshBlockAnimation
       */
      refreshBlockAnimation: function() {
        var all = Drupal.Theme.load('all');
        var deltaTop = parseInt($('.header-site').outerHeight());

        $('.paragraph--type--block-animation .field_image').each(function () {
          if (all.isScrolledIntoView($(this), deltaTop, 200) && !$(this).closest('.paragraph--type--block-animation').hasClass('anim-started')) {
            $(this).closest('.paragraph--type--block-animation').addClass('anim-started');
          }
        });
      },

      /**
       * POC Hubspot
       */
      /*initHuspotForm: function() {
          if ($('.form-hubspot').length && $('body').hasClass('debug')) {
              $('.form-hubspot').hide();
              setTimeout(function () {
                  $('.hs-form > *').each(function (index) {
                      if (index == 0) {
                          $(this).addClass('active')
                      } else if ($(this)[0].tagName == 'FIELDSET') {
                          $(this).hide();
                      }
                  });
                  $('<button class="btn-prev">Précédent</button>').insertBefore('.hs-submit');
                  $('<button class="btn-next">Suivant</button>').insertBefore('.hs-submit');

                  $('.hs-form .btn-prev').on('click touch', function (e) {
                      e.preventDefault();
                      let objPrev = $('.hs-form > .active').prev();
                      if (objPrev.length > 0) {
                          if (objPrev[0].tagName == 'FIELDSET') {
                              $('.hs-form > .active').hide().removeClass('active');
                              objPrev.show().addClass('active');
                          }
                      }
                  });
                  $('.hs-form .btn-next').on('click touch', function (e) {
                      e.preventDefault();
                      let objNext = $('.hs-form > .active').next();
                      if (objNext.length > 0) {
                          if (objNext[0].tagName == 'FIELDSET') {
                              $('.hs-form > .active').hide().removeClass('active');
                              objNext.show().addClass('active');
                          }
                      }
                  });


                  $('.form-hubspot').show();
              }, 700);
          }
      },*/


  };

}(jQuery, Drupal, drupalSettings, window.Cookies));
